export type Product = {
  slug: string;
  name: string;
  eyebrow: string;
  description: string;
  price: number;
  image: string;
  mood: "Celebration" | "Comfort" | "New beginnings";
  contents: string[];
  accent: "rose" | "sage" | "gold";
};

export const products: Product[] = [
  {
    slug: "a-little-light",
    name: "A Little Light",
    eyebrow: "For a difficult week",
    description:
      "A quiet collection of comforting rituals, chosen to make an ordinary evening feel held.",
    price: 58,
    image: "/assets/comfort-hamper.webp",
    mood: "Comfort",
    contents: [
      "Botanical sleep tea",
      "Ribbed ceramic mug",
      "Natural soy candle",
      "Soft eye mask",
      "Artisan chocolate",
      "Handwritten gift note"
    ],
    accent: "sage"
  },
  {
    slug: "the-good-news",
    name: "The Good News",
    eyebrow: "For something worth celebrating",
    description:
      "Beautiful little luxuries for marking a win, a milestone, or a well-earned new beginning.",
    price: 76,
    image: "/assets/celebration-hamper.webp",
    mood: "Celebration",
    contents: [
      "Sparkling botanical drink",
      "Blush glass candle",
      "Hand-finished truffles",
      "Sculptural bud vase",
      "Linen-bound keepsake card"
    ],
    accent: "rose"
  },
  {
    slug: "a-new-chapter",
    name: "A New Chapter",
    eyebrow: "For what comes next",
    description:
      "Thoughtful pieces for the first night in a new home, a brave new job, or the start of something.",
    price: 68,
    image: "/assets/hero-hamper.webp",
    mood: "New beginnings",
    contents: [
      "Cream ceramic candle",
      "Botanical loose-leaf tea",
      "Artisan dark chocolate",
      "Natural linen pouch",
      "Keepsake note card"
    ],
    accent: "gold"
  },
  {
    slug: "just-because",
    name: "Just Because",
    eyebrow: "For no reason but them",
    description:
      "An unprompted pause: tea, chocolate and tactile comforts, sent simply because they crossed your mind.",
    price: 52,
    image: "/assets/comfort-hamper.webp",
    mood: "Comfort",
    contents: [
      "Botanical tea",
      "Small-batch chocolate",
      "Travel candle",
      "Soft eye mask",
      "Personal gift note"
    ],
    accent: "rose"
  },
  {
    slug: "proud-of-you",
    name: "Proud of You",
    eyebrow: "For the moment they made",
    description:
      "A celebratory edit that says you noticed the courage, work and heart it took to get here.",
    price: 82,
    image: "/assets/celebration-hamper.webp",
    mood: "Celebration",
    contents: [
      "Sparkling botanical drink",
      "Artisan truffle selection",
      "Blush candle",
      "Ceramic bud vase",
      "Keepsake card"
    ],
    accent: "gold"
  },
  {
    slug: "soft-landing",
    name: "Soft Landing",
    eyebrow: "For settling in",
    description:
      "A warm welcome for a new home, a new baby, or any unfamiliar place that needs to feel like theirs.",
    price: 72,
    image: "/assets/hero-hamper.webp",
    mood: "New beginnings",
    contents: [
      "Ceramic candle",
      "Breakfast tea",
      "Chocolate sharing bar",
      "Linen pouch",
      "Botanical arrangement"
    ],
    accent: "sage"
  }
];

export const journalPosts = [
  {
    slug: "when-words-feel-small",
    category: "The art of gifting",
    title: "What to send when words feel small",
    excerpt:
      "A considered guide to showing up for someone in a difficult season — gently, usefully and without asking them to perform.",
    date: "18 July 2026"
  },
  {
    slug: "gift-note-guide",
    category: "Words that stay",
    title: "How to write a gift note that actually means something",
    excerpt:
      "You do not need to be poetic. You only need to be specific, sincere, and willing to say the thing you nearly left unsaid.",
    date: "04 July 2026"
  },
  {
    slug: "new-chapter-gifts",
    category: "New beginnings",
    title: "The best gifts for a brave new chapter",
    excerpt:
      "For new jobs, new homes and uncertain first days: small ways to make change feel celebrated and held.",
    date: "22 June 2026"
  }
];

export const faqs = [
  {
    question: "Does Trio Atelier Co. deliver across the UK?",
    answer:
      "Yes. We prepare every hamper in our Leeds studio and deliver to addresses across the UK. Standard tracked delivery is typically 2–4 working days after dispatch."
  },
  {
    question: "Can I add a personalised gift note?",
    answer:
      "Always. Add your message at the product page or during checkout. We print it on our signature card and include it inside the hamper at no extra charge."
  },
  {
    question: "Can the hamper be sent directly to the recipient?",
    answer:
      "Yes. Enter their delivery address at checkout and your own details for billing. We never include pricing in the parcel."
  },
  {
    question: "Can I choose a future delivery date?",
    answer:
      "You can request a preferred arrival date at checkout. We will time dispatch as closely as possible, although courier delays can occasionally affect the exact day."
  },
  {
    question: "Do you create corporate or bespoke gifts?",
    answer:
      "Yes. We create thoughtful client, colleague and event gifting from small considered runs to larger branded projects. Use our corporate enquiry form to begin."
  },
  {
    question: "What about allergens?",
    answer:
      "Food and drink product pages list known allergens. Because hampers are assembled in a shared studio, please speak with us before ordering for a severe allergy."
  }
];

export const builderItems = [
  { id: "tea", name: "Botanical tea", price: 9, category: "Sip" },
  { id: "sparkling", name: "Sparkling botanical", price: 14, category: "Sip" },
  { id: "candle", name: "Ceramic candle", price: 18, category: "Pause" },
  { id: "mask", name: "Soft eye mask", price: 12, category: "Pause" },
  { id: "chocolate", name: "Artisan chocolate", price: 11, category: "Taste" },
  { id: "truffles", name: "Hand-finished truffles", price: 16, category: "Taste" },
  { id: "vase", name: "Sculptural bud vase", price: 17, category: "Keep" },
  { id: "pouch", name: "Natural linen pouch", price: 8, category: "Keep" }
];
